module.exports = __webpack_public_path__ + "img/spotify.97e6e73c.png";